import React from 'react';
import { Section } from '../components/ui/Section';
import { motion } from 'framer-motion';
interface TeamMember {
  name: string;
  role: string;
  image: string;
}
const TeamMemberCard: React.FC<TeamMember & {
  index: number;
}> = ({
  name,
  role,
  image,
  index
}) => {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: index * 0.1
  }} className="bg-white rounded-2xl overflow-hidden shadow-lg border-2 border-gray-100 hover:shadow-xl transition-shadow duration-300" data-id="element-717">
      <div className="aspect-square overflow-hidden bg-[#F2F0E7]" data-id="element-718">
        <img src={image} alt={name} className="w-full h-full object-cover" data-id="element-719" />
      </div>
      <div className="p-6 text-center" data-id="element-720">
        <h3 className="text-xl font-bold text-[#1C274C] mb-2" data-id="element-721">{name}</h3>
        <p className="text-gray-600 font-medium" data-id="element-722">{role}</p>
      </div>
    </motion.div>;
};
export const Team = () => {
  const founder: TeamMember = {
    name: 'Godsgift Eseoghena Braimah',
    role: 'Founder',
    image: 'https://cdn.magicpatterns.com/uploads/dugubDv5EJfJ8AjDXbDCz7/Godsgift_Eseoghena_Braimah.png'
  };
  const instructionalAdvisor: TeamMember = {
    name: 'Grace Idiare',
    role: 'Instructional Advisor',
    image: 'https://cdn.magicpatterns.com/uploads/kwaZQRZD43FccxGD3A91Qi/Grace_Idiare.png'
  };
  const adminTeam: TeamMember[] = [{
    name: 'Ifeoluwa Adeyeye-Kayode',
    role: 'Admin & Operations',
    image: 'https://cdn.magicpatterns.com/uploads/qimGNeNNGweV969WpxnMxi/Ifeoluwa_Adeyeye-Kayode.png'
  }, {
    name: 'Okosun Elizabeth',
    role: 'Admin & Operations',
    image: 'https://cdn.magicpatterns.com/uploads/anjrfBxEnqH1y3zHPJovaD/Okosun_Elizabeth.png'
  }];
  const researchTeam: TeamMember[] = [{
    name: 'Adejumobi Joshua',
    role: 'AI Research & Innovation',
    image: 'https://cdn.magicpatterns.com/uploads/e3HFHrbVeNLsfMgVX69roX/Adejumobi_Joshua.png'
  }, {
    name: 'Felix Frank-Felix',
    role: 'AI Research & Innovation',
    image: 'https://cdn.magicpatterns.com/uploads/ggM23Rtof9miMKGu2yafNd/Felix_Frank-Felix.png'
  }, {
    name: 'Kingsley Ibekwe',
    role: 'AI Research & Innovation',
    image: 'https://cdn.magicpatterns.com/uploads/dTypqBjBeB5o5ArrmuvgrZ/Kingsley_Ibekwe.png'
  }];
  const mediaTeam: TeamMember[] = [{
    name: 'Imafidon Glory',
    role: 'Media & Communications',
    image: 'https://cdn.magicpatterns.com/uploads/ffKycJ5ir52XXkCLeLfNJU/Imafidon_Glory.png'
  }, {
    name: 'Deborah Braimah',
    role: 'Media & Communications',
    image: 'https://cdn.magicpatterns.com/uploads/p3gUKAVW3uaqUoLrjgkTga/Deborah_Braimah.png'
  }, {
    name: 'Michael Ethel',
    role: 'Media & Communications',
    image: 'https://cdn.magicpatterns.com/uploads/qJF24H1uLsyjf8BE5JKqgG/Michael_Ethel.png'
  }];
  return <div className="pt-20" data-id="element-723">
      {/* Hero */}
      <div className="bg-[#F2F0E7] py-20 md:py-32" data-id="element-724">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-725">
          <h1 className="text-4xl md:text-6xl font-bold text-[#1C274C] mb-6" data-id="element-726">
            Our Team
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-727">
            Meet the dedicated individuals driving AI education across Africa.
          </p>
        </div>
      </div>

      {/* Founder */}
      <Section data-id="element-728">
        <div className="max-w-6xl mx-auto" data-id="element-729">
          <div className="text-center mb-12" data-id="element-730">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1C274C] mb-4" data-id="element-731">
              Founder
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-732">
              Leading the vision to empower African children through AI
              education.
            </p>
          </div>

          <div className="max-w-sm mx-auto" data-id="element-733">
            <TeamMemberCard {...founder} index={0} data-id="element-734" />
          </div>
        </div>
      </Section>

      {/* Instructional Advisor */}
      <Section background="gray" data-id="element-735">
        <div className="max-w-6xl mx-auto" data-id="element-736">
          <div className="text-center mb-12" data-id="element-737">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1C274C] mb-4" data-id="element-738">
              Instructional Advisor
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-739">
              Guiding our educational approach and curriculum development.
            </p>
          </div>

          <div className="max-w-sm mx-auto" data-id="element-740">
            <TeamMemberCard {...instructionalAdvisor} index={0} data-id="element-741" />
          </div>
        </div>
      </Section>

      {/* Admin and Operations Team */}
      <Section data-id="element-742">
        <div className="max-w-6xl mx-auto" data-id="element-743">
          <div className="text-center mb-12" data-id="element-744">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1C274C] mb-4" data-id="element-745">
              Admin & Operations Team
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-746">
              Ensuring smooth operations and sustainable growth of our programs.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto" data-id="element-747">
            {adminTeam.map((member, index) => <TeamMemberCard key={member.name} {...member} index={index} data-id="element-748" />)}
          </div>
        </div>
      </Section>

      {/* AI Research and Innovation Team */}
      <Section background="gray" data-id="element-749">
        <div className="max-w-6xl mx-auto" data-id="element-750">
          <div className="text-center mb-12" data-id="element-751">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1C274C] mb-4" data-id="element-752">
              AI Research & Innovation Team
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-753">
              Pioneering ethical AI solutions and developing cutting-edge
              educational content.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-754">
            {researchTeam.map((member, index) => <TeamMemberCard key={member.name} {...member} index={index} data-id="element-755" />)}
          </div>
        </div>
      </Section>

      {/* Media and Communications Team */}
      <Section data-id="element-756">
        <div className="max-w-6xl mx-auto" data-id="element-757">
          <div className="text-center mb-12" data-id="element-758">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1C274C] mb-4" data-id="element-759">
              Media & Communications Team
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-760">
              Amplifying our mission and connecting with communities across
              Africa.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-761">
            {mediaTeam.map((member, index) => <TeamMemberCard key={member.name} {...member} index={index} data-id="element-762" />)}
          </div>
        </div>
      </Section>

      {/* Join Us CTA */}
      <Section background="gray" className="text-center" data-id="element-763">
        <div className="max-w-3xl mx-auto bg-white p-12 rounded-3xl border-2 border-gray-200 shadow-lg" data-id="element-764">
          <h2 className="text-3xl font-bold text-[#1C274C] mb-4" data-id="element-765">
            Want to Join Our Team?
          </h2>
          <p className="text-gray-600 mb-8" data-id="element-766">
            We're always looking for passionate individuals who share our vision
            of empowering African children through AI education.
          </p>
          <a href="https://forms.gle/mj5tBF2xmD7tmg12A" target="_blank" rel="noopener noreferrer" data-id="element-767">
            <button className="bg-[#1C274C] text-white font-bold text-lg px-8 py-4 rounded-full hover:bg-[#2a3a6b] transition-colors shadow-lg" data-id="element-768">
              Volunteer With Us
            </button>
          </a>
        </div>
      </Section>
    </div>;
};